module.exports = __webpack_public_path__ + "img/search_none.14111a9f.png";